import { Reveal } from "./motion";

const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_real-talk-starter/artifacts/0qt1fybb_me610.PNG";

export const Author = () => {
  return (
    <section className="bg-cloud py-20 md:py-28" data-testid="author-section">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-12 px-5 md:px-10 md:grid-cols-2 md:gap-16">
        <Reveal className="order-2 md:order-1">
          <div className="relative w-full max-w-md">
            <div className="border-4 border-ink shadow-[12px_12px_0px_0px_#00E5FF]">
              <img
                src={PORTRAIT}
                alt="Jason Integrity"
                className="aspect-[4/5] w-full object-cover object-top"
                data-testid="author-portrait"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 z-10 border-2 border-ink bg-acid px-4 py-2 font-mono text-xs font-bold uppercase tracking-[0.16em] text-ink">
              Army Veteran
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="order-1 md:order-2">
          <p className="mb-5 font-mono text-xs font-bold uppercase tracking-[0.22em] text-ink/50">
            Who wrote this
          </p>
          <h2 className="font-display text-4xl font-black uppercase tracking-tight text-ink sm:text-5xl" data-testid="author-name">
            Jason Integrity
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-ink/80">
            Army veteran, sales strategist, and author of{" "}
            <span className="font-bold text-ink">Selling Without Selling: Dope People Sell Dope Shit.</span>
          </p>
          <p className="mt-4 text-lg leading-relaxed text-ink/70">
            He has spent his career proving that people buy from people they{" "}
            <span className="font-semibold text-ink">know, like, trust, and understand</span>, and that not
            one of those four things happens while you are talking.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
